<section class="tool">
    <ng-content select="app-quote-drawer-heading"></ng-content>
    <section class="tool__content">
        <h3 class="tool__content-heading">Sales Process Tool</h3>
        <p *ngIf="!(brandedNotes$ | async)?.length && !(unBrandedNotes$ | async)?.length">No notes for this page for this brand.<p>
        <ul>
            <li class="tool__content-note"
                *ngFor="let note of unBrandedNotes$ | async"
            >
                <app-sales-process-note 
                    [note]="note"
                ></app-sales-process-note>
            </li>
        </ul>

        <h4 *ngIf="(brandedNotes$ | async)?.length" class="tool__content-brand-heading">IF {{(brandedNotes$ | async)![0].brand | uppercase}}:</h4>
        <ul>
            <li class="tool__content-note"
            *ngFor="let note of brandedNotes$ | async"
        >
            <app-sales-process-note 
                [note]="note"
            ></app-sales-process-note>
        </li>
        </ul>
    </section>
</section>